import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import TextArea from '../UI/Control/InputTextarea';
import SelectList from '../UI/Control/SelectList';
import { useSelector } from 'react-redux'
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import InputRadio from '../UI/Control/InputRadio';

const ConfirmUnscheduleVisit = (props) => {
    const [arrVisit, setArrVisit] = useState([]);
    let taskId = props.taskId;
    const EDCUserID = useSelector(state => state.auth.gValue01);
    useEffect(() => {
        FillVisitList();
        document.getElementById('confVisitChange').checked = true;
    }, [])

    const FillVisitList = () => {
        fetch('api/ImageService/FillVisitList?taskId=' + props.taskId)
            .then(response => response.json())
            .then(data => {
                let arr = [{ Value: '', Name: '--Select Visit--' }]
                for (var iCount = 0; iCount < data.length; iCount++) {
                    arr.push({ Value: data[iCount].Value, Name: data[iCount].Name });
                }
                setArrVisit(arr);
            });
    }
    const saveConfirmVisit = () => {
        let usrAction;
        let objNotes = document.getElementById('txtNotes');
        let objVisit = document.getElementById('ddlVisitList');
        let objAction = document.querySelector("input[name=ConfirmVisit]:checked");
        if (objAction == null)
        {
            alert('Choose either to modify the visit or to confirm the unscheduled visit!');
            objAction.focus();
            return false;
        }

        if (document.getElementById('confVisitChange').checked == true && objVisit.value.trim() == '') {
            alert('Please select visit.');
            objVisit.focus();
            return false;
        }

        if (document.getElementById('confVisitUnschedule').checked == true && objVisit.value.trim() == '') {
            alert('Unscheduled visit not selected.');
            objVisit.focus();
            return false;
        }

        if (objNotes.value.trim() == '') {
            alert('Notes should not be empty.');
            objNotes.focus();
            return false;
        }

        if (objAction.value == 'Y') {
            usrAction = 'ChangeVisit'
        }
        else {
            usrAction = 'ConfUnScheduledVisit'
        }
        let objConfirmVisitModel = {
            TaskID: taskId,
            Notes: objNotes.value,
            Action: usrAction,
            VisitID: objVisit.value
        };

        fetch('api/ImageService/SaveConfirmVisit', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(objConfirmVisitModel)
        })
        .then(r => r.json())
        .then(res => {
            if (res == -1) {
                alert('Visit not updated, Something went wrong.');
            }
            if (res == -2) {
                alert('Unable to create Unscheduled visit, Something went wrong.');
            }
            if (res > 0) {
                props.relaodAction();
            }
        })
    };
    const onChangeVisitHandler = (e) => {
        if (e.target.value == 'Y') {
            document.getElementById('confVisitUnschedule').checked = false;
            document.getElementById('confVisitChange').checked = true;
            document.getElementById("ddlVisitList").disabled = false;
            document.getElementById("ddlVisitList").value = "";
        }
        else {
            document.getElementById('confVisitUnschedule').checked = true;
            document.getElementById('confVisitChange').checked = false;
            document.getElementById("ddlVisitList").disabled = true;
            document.getElementById("ddlVisitList").value = "";
            const dropdown = document.getElementById("ddlVisitList");
            dropdown.disabled = true;
            for (let i = 0; i < dropdown.options.length; i++) {
                if (dropdown.options[i].text === "Unscheduled") {
                    dropdown.selectedIndex = i;
                    break;
                }
            }
        }
    }
    
    return (
        <div>
            <Row className="mt-2 mb-2">
                <Col md={5}>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            <InputRadio id="confVisitChange" orientation='horizontal' value="Y" name="ConfirmVisit"
                                text="Wants to change the Visit" style={{ "margin-left": "15px", "margin-right": "10px" }}
                                onChange={onChangeVisitHandler}> </InputRadio>
                 </Col>
                        <Col md={6}>
                            <SelectList id="ddlVisitList" dataSource={arrVisit} />
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col md={6}>
                            <InputRadio id="confVisitUnschedule" orientation='horizontal' value="N" name="ConfirmVisit"
                                text="Visit / Confirmed as Unscheduled Visit" style={{ "margin-left": "15px", "margin-right": "10px" }}
                                onChange={onChangeVisitHandler}> </InputRadio>
                 </Col>                        
                    </Row>
                </Col>
                <Col md={1} style={{ "margin-left": "30px", width: "80px" }}>Notes<MandatoryLabel/>: </Col>
                <Col md={5}>
                    <TextArea id="txtNotes" rows='5' cols='70' />
                </Col>
                <Col md={1}> <Button style={{ marginTop: "90px" }} className="btn-success" onClick={saveConfirmVisit} > Submit </Button></Col>
            </Row>
        </div>
    );
}
export default ConfirmUnscheduleVisit;
